// Refactor: ogni pagina è un layout di blocchi.
// I blocchi "system_page_*" rendono il contenuto principale della pagina;
// l'utente può aggiungere blocchi (text/image/video/iframe/banner/gallery) prima o dopo.

import ChiSiamo from '../pages/ChiSiamo';
import Contatti from '../pages/Contatti';
import Squadre from '../pages/Squadre';
import Regolamento from '../pages/Regolamento';
import Calendario from '../pages/Calendario';
import Classifiche from '../pages/Classifiche';
import EdizioniPassate from '../pages/EdizioniPassate';
import Partners from '../pages/Partners';
import Gallery from '../pages/Gallery';
import Videos from '../pages/Videos';

export const PAGE_SYSTEM_COMPONENTS = {
  system_page_chisiamo: ChiSiamo,
  system_page_contatti: Contatti,
  system_page_squadre: Squadre,
  system_page_regolamento: Regolamento,
  system_page_calendario: Calendario,
  system_page_classifiche: Classifiche,
  system_page_edizioni: EdizioniPassate,
  system_page_partners: Partners,
  system_page_gallery: Gallery,
  system_page_videos: Videos,
};
